import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { ClassAttendanceUpdateRequest } from "./ClassAttendanceUpdateRequest";
import { ClassAttendanceStudentHistoryRequest } from "./ClassAttendanceStudentHistoryRequest";

@Injectable()
export class DataService_Student_Class_Attendance {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	ClassAttendanceStatsInfoGetList(PersonID, StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "ClassAttendance/ClassAttendanceStatsInfoGetList?PersonID=" + PersonID + "&StartDate=" + StartDate + "&EndDate=" + EndDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ClassAttendanceTableInfoGetList(PersonID, StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "ClassAttendance/ClassAttendanceTableInfoGetList?PersonID=" + PersonID + "&StartDate=" + StartDate + "&EndDate=" + EndDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ClassAttendanceStatusInfoGetList() {
		var postResult$ = new Subject();
		var url = "ClassAttendance/ClassAttendanceStatusInfoGetList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ClassAttendanceExcuseInfoGetList(SchoolID) {
		var postResult$ = new Subject();
		var url = "ClassAttendance/ClassAttendanceExcuseInfoGetList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ClassAttendanceUpdate(parms: ClassAttendanceUpdateRequest) {
		var postResult$ = new Subject();
		var url = "ClassAttendance/ClassAttendanceUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ClassAttendanceStudentHistoryInfoGetList(parms: ClassAttendanceStudentHistoryRequest) {
		var postResult$ = new Subject();
		var url = "ClassAttendance/ClassAttendanceStudentHistoryInfoGetList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
